// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ff7e29cb","239":"f203d6ff","453":"d4f29c86","686":"e1da7448","732":"85342613","953":"f463b1a2"}[chunkId] + ".chunk.js";
};